import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';

@Component({
  selector: 'app-control-select',
  styleUrls: ['./control-select.component.scss'],
  templateUrl: './control-select.component.html',
})
export class ControlSelectComponent extends ControlBaseComponent implements OnInit{

  @Input()  items: any[];
  @Input()  isBadges: boolean;
  @Input()  isDisabled: boolean;
  @Input()  isRequired: boolean;
  @Input()  isDialog: boolean;
  @Input()  isClearable: boolean = true;
  @Input()  placeholder: string;
  @Input()  label: string;
  @Input()  model: any;//wszystkie kontrolery tupu kontrol muszą kożystac z modelu który jest klasą, w przeciwnym wypadku nie ma prawidłowej propagacji zmiennych i trzeba by używać explicite emiterów
  @Input()  modelBindValue: string;//wartość opcjonalna - należy podać tylko wówczas gdy bidValue jest inne niż wartość do której się podłaczamy w modelu
  @Input()  bindLabel: string;
  @Input()  bindValue: string;
  @Input()  cssClass: string;
  @Input() controlName: any;
  @Input() inlineControl = false;

  @Output() ngModelChange = new EventEmitter();


  constructor(public helperService: HelperService,
              private changeDetection: ChangeDetectorRef  ) {
    super(helperService);
  }

  ngOnInit(): void {
    if (!this.modelBindValue) {
      this.modelBindValue = this.bindValue;
    }
  }

  ModelChange() {
    if (this.ngModelChange) {
      this.ngModelChange.emit();
    }
  }
}
